import { useEffect, useState } from "react";
import { DEV_SERVER } from "../../../constants/urls";
import { userSignal } from "../../../signal/userSignal";
import axios from "axios";
import { useMutation, useQuery } from "react-query";
import { Form, Modal } from "react-bootstrap";
import Select from "react-select";
import CreatableSelect from 'react-select/creatable';
import { productSignal } from "../../../signal/productSignal";
import { toast } from "react-toastify";
import TopLoader from "react-top-loader";


export default function AddReturnedItemModal(props) {

    const [order, setOrder] = useState(props?.order ? props.order : {
        id: '',
        dealerId: '',
        orderItems: [],
        returnItems: [],
        subTotal: 0,
        totalAmount: 0,
        discounts: [],
        taxes: [],
        shippingCharges: 0,
        userCommissionInPercentage: 0,
        shippingAddress: {
            addressL1: '',
            landmark: '',
            area: '',
            city: '',
            state: '',
            pincode: '',
            country: ''
        },
        billingAddress: {
            addressL1: '',
            landmark: '',
            area: '',
            city: '',
            state: '',
            pincode: '',
            country: ''
        },
        note: '',
    });
    const [returnItems, setReturnItems] = useState([]);
    const [products, setProducts] = useState(null);

    const getProducts = useQuery("products", async () => {
        let resp = await axios.get(`${DEV_SERVER}/product/v2`, {
            headers: {
                Authorization: `Bearer ${userSignal.value?.token}`,
            },

        });
        return resp.data;
    }, {
        enabled: false,
        onSuccess: (data) => {
            if (data.status) {
                let temp = order?.products ? order?.products : {}
                data?.data?.map((product) => {
                    temp[product.id] = product
                })

                setProducts(temp)
                productSignal.value = temp

            } else {
                toast.error(data.message);
            }
        },

        onError: (error) => {
            if (error.response?.data?.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error("Something went wrong");
            }
        }
    });

    const addReturnItems = useMutation(async (data) => {
        let resp = await axios.post(`${DEV_SERVER}/order/v2/return-items/${data?.id}`, data?.body, {
            headers: {
                Authorization: `Bearer ${userSignal.value?.token}`,
            },
        });
        return resp.data;
    }, {
        onSuccess: (data) => {
            if (data.status) {
                toast.success(data.message);
                props.refetchOrder()
                props.close()
            } else {
                toast.error(data.message);
            }
        },

        onError: (error) => {
            if (error.response?.data?.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error("Something went wrong");
            }
        }
    });

    useEffect(() => {
        if (products === null) {
            if (order?.products) {
                setProducts({ ...order?.products })
            } else {
                getProducts.refetch({ cancelRefetch: true })
            }
        }

        if (props?.order) {
            setOrder(props.order);
            setReturnItems(props.order?.orderItems || [])
        }
    }, [props?.order]);

    const handleSubmit = () => {
        let data = {
            id: order?.id,
            body: {
                returnItems: returnItems
            }
        }
        addReturnItems.mutate(data)
    }

    return (
        <>
            {products === null ? <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
                <div className="spinner-border text-primary m-2" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div> :

                <Modal show={props.show} onHide={props.close} fullscreen>
                    <Modal.Header closeButton>
                        <Modal.Title>Add Returned Items Entry</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>\
                        {addReturnItems.isLoading && <div>
                            <TopLoader backgroundColor="#eee6ff" show fixed={true} color="#0000e4" />
                        </div>}
                        <Form className="w-75 mx-auto d-flex flex-wrap justify-content-center align-items-center">

                            <div className="mt-5" style={{ display: "flex", flexDirection: "column", width: "75%" }}>
                                <div>
                                    {returnItems?.length > 0 && returnItems?.map((returnItem, index) => {
                                        return (
                                            <div key={index} className='d-flex flex-column mb-2'>
                                                <div style={{ display: "flex", columnGap: "1rem", alignItems: "end" }}>
                                                    <Form.Group className="form-group">
                                                        <i>{(index + 1) + "."}</i>
                                                    </Form.Group>
                                                    <Form.Group className="form-group" style={{ width: "40%" }}>
                                                        <Form.Label>Product</Form.Label>
                                                        <Select
                                                            as="select"
                                                            value={{ label: products[returnItem?.productId]?.name, value: returnItem?.productId }}
                                                            onChange={(e) => {
                                                                let temp = [...returnItems]
                                                                temp[index].productId = e?.value
                                                                temp[index].quantity = 1
                                                                setReturnItems(temp)

                                                            }}
                                                            options={Object.entries(products).map(([key, value]) => {
                                                                return (
                                                                    {
                                                                        label: value?.name,
                                                                        value: key.toString()
                                                                    }
                                                                )
                                                            })}
                                                            isSearchable
                                                            isClearable
                                                        />
                                                    </Form.Group >
                                                    <Form.Group className="form-group" style={{ width: '20%' }}>
                                                        <Form.Label>Packaging</Form.Label>
                                                        <CreatableSelect
                                                            as="select"
                                                            value={{ label: returnItem?.packagingType, value: returnItem?.packagingType }}
                                                            onChange={(e) => {
                                                                let temp = [...returnItems]
                                                                temp[index].packagingType = e?.value
                                                                setReturnItems(temp)
                                                            }}
                                                            options={products[returnItem?.productId]?.packagingTypes?.map((packagingType) => {
                                                                return (
                                                                    {
                                                                        label: packagingType,
                                                                        value: packagingType
                                                                    }
                                                                )
                                                            })}
                                                            isSearchable

                                                        />
                                                    </Form.Group >
                                                    <Form.Group className="form-group" style={{ width: '10%' }}>
                                                        <Form.Label>Qty</Form.Label>
                                                        <Form.Control type="number" className="" id="quantity" aria-describedby="quantity" placeholder="quantity" value={returnItem?.quantity} onChange={(e) => {
                                                            let temp = [...returnItems]
                                                            temp[index].quantity = parseInt(e.target.value)
                                                            setReturnItems(temp)
                                                        }} />
                                                    </Form.Group >
                                                    <Form.Group className="form-group">
                                                        <i className='fa fa-trash' style={{ cursor: "pointer" }} onClick={() => {
                                                            let temp = [...returnItems]
                                                            temp.splice(index, 1)
                                                            setReturnItems(temp)
                                                        }}></i>
                                                    </Form.Group >
                                                </div>
                                            </div>
                                        )
                                    })}
                                    <div className="d-flex justify-content-between align-items-center">
                                        <button className='btn btn-light mt-2' onClick={(e) => {
                                            e.preventDefault()
                                            let temp = [...returnItems || []] || []
                                            temp.push({
                                                productId: "",
                                                quantity: 0,
                                                packagingType: ""
                                            })

                                            setReturnItems(temp)
                                        }}>Add Item</button>
                                    </div>
                                </div>
                            </div>

                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        <button className="btn btn-primary" onClick={handleSubmit} disabled={addReturnItems.isLoading}>{addReturnItems.isLoading ? "Adding..." : "Add"}</button>
                        <button className="btn btn-light" onClick={props.close}>Close</button>
                    </Modal.Footer>
                </Modal>

            }

        </>
    )
}